/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */

import {
  AGENT_CHAT_ADD_MESSAGE,
  AGENT_CHAT_CLEAR,
  AGENT_CHAT_HISTORY_RESPONSE,
} from '#constants/actionTypes.js';

// State shape: { [modelId]: { messages: Array<Message>, generation: ?number } }
const initialState = {};

const emptyEntry = { messages: [], generation: null };

const agentChat = (state, action) => {
  if (state === undefined) return initialState;
  switch (action.type) {
    case AGENT_CHAT_ADD_MESSAGE: {
      const { modelId, message } = action.payload;
      const existing = state[modelId] || emptyEntry;
      return {
        ...state,
        [modelId]: {
          ...existing,
          messages: [...existing.messages, message],
        },
      };
    }
    case AGENT_CHAT_HISTORY_RESPONSE: {
      if (action.error) return state;
      const { modelId } = action.meta;
      const payload = action.payload || {};
      return {
        ...state,
        [modelId]: {
          messages: Array.isArray(payload.messages) ? payload.messages : [],
          generation: typeof payload.generation === 'number' ? payload.generation : null,
        },
      };
    }
    case AGENT_CHAT_CLEAR: {
      const { modelId, generation } = action.payload;
      return {
        ...state,
        [modelId]: {
          messages: [],
          generation: typeof generation === 'number' ? generation : null,
        },
      };
    }
    default:
      return state;
  }
};

export default agentChat;
